import { render, staticRenderFns } from "./RecordingDialog.vue?vue&type=template&id=099bb586&scoped=true"
import script from "./RecordingDialog.vue?vue&type=script&lang=js"
export * from "./RecordingDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordingDialog.vue?vue&type=style&index=0&id=099bb586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099bb586",
  null
  
)

export default component.exports